import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import EasySlider from 'vue-easy-slider'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueTouch from 'vue-touch'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

const app = createApp(App)

app.use(VueTouch, {name: 'v-touch'}).use(VueAxios, axios).use(ElementPlus).use(router).use(EasySlider)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

app.mount('#app')